import Circle from '../progressCircle/progressCircle';
import Container from '../../atoms/container/RatingContainer';

const Rating = ({
  color,
  margin,
  percentage,
  rating,
  Logo,
}: {
  color?: string;
  margin?: number;
  percentage?: number;
  rating?: string;
  Logo?: (props: object) => JSX.Element;
}) => {
  const parsedRating = parseInt(rating || '');
  return rating && parsedRating > 0 && !Number.isNaN(parsedRating) ? (
    <Container margin={margin}>
      {Logo ? <Logo /> : null}
      <Circle
        color={color}
        margin={!!Logo}
        percentage={percentage}
        text={rating}
      />
    </Container>
  ) : null;
};

export default Rating;
